import {Button, Dialog, DialogActions, DialogContent, Stack, Typography} from "@mui/material";
import {MyDialogTitle} from "@/components/dialog/MyDialogTitle.tsx";
import {z} from "zod";
import {zodResolver} from "@hookform/resolvers/zod";
import {FormProvider, useForm} from "react-hook-form";
import {FormTextField} from "@/components/form/FormTextField.tsx";
import {useCallback} from "react";
import {RealEstateTransactionSpecialistFragmentFragment, useCreateRealEstateTransactionSpecialistMutation,} from "@/graphql/graphql";
import toast from "react-hot-toast";

interface CreateNewRealEstateTransactionSpecialistDialogProps {
  open: boolean;
  onClose: () => void;
  onCreateSuccess?: (value: RealEstateTransactionSpecialistFragmentFragment) => Promise<void>;
}

const schema = z.object({
  registrationNumber: z.string().min(4),
  name: z.string().min(2),
  officeName: z.string().min(2),
  officeAddress: z.string().min(2),
  phoneNumber: z.string().min(3),
})

export function CreateNewRealEstateTransactionSpecialistDialog(
  {open, onClose, onCreateSuccess}: CreateNewRealEstateTransactionSpecialistDialogProps
) {
  
  const create = useCreateRealEstateTransactionSpecialistMutation()
  
  const form = useForm({
    defaultValues: {
      registrationNumber: '',
      name: '',
      officeName: '',
      officeAddress: '',
      phoneNumber: '',
    },
    resolver: zodResolver(schema),
    mode: "onChange"
  })
  
  const onSubmit = useCallback(async (
    value: z.infer<typeof schema>
  ) => {
    const toastId = toast.loading('作成中...')
    await create.mutateAsync({
      input: value
    }).then(
      (res) => {
        if (res.createRealEstateTransactionSpecialist) {
          toast.success('作成しました', {id: toastId})
          onClose()
          if (onCreateSuccess) {
            onCreateSuccess(res.createRealEstateTransactionSpecialist)
          }
        }
      }
    ).catch(
      () => {
        toast.error('作成に失敗しました', {id: toastId})
      }
    )
  }, [create, onClose, onCreateSuccess])
  
  return <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
    <MyDialogTitle
      onClose={onClose}
    >
      宅地建物取引士 新規作成
    </MyDialogTitle>
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <DialogContent>
          <Stack spacing={1}>
            <Typography variant={'formLabel'}>登録番号</Typography>
            <FormTextField name={'registrationNumber'} control={form.control} placeholder={'東京都知事(1)第12345号'}/>
            <Typography variant={'formLabel'}>氏名</Typography>
            <FormTextField name={'name'} control={form.control} placeholder={'不動産太郎'}/>
            <Typography variant={'formLabel'}>業務に従事する事務所名</Typography>
            <FormTextField name={'officeName'} control={form.control} placeholder={'株式会社不動産 渋谷支店'}/>
            <Typography variant={'formLabel'}>業務に従事する事務所の所在地</Typography>
            <FormTextField name={'officeAddress'} control={form.control} placeholder={'東京都渋谷区渋谷1-1-1'}/>
            <Typography variant={'formLabel'}>電話番号</Typography>
            <FormTextField name={'phoneNumber'} control={form.control} placeholder={'03-1234-5678'}/>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>キャンセル</Button>
          <Button type={'submit'} variant={'contained'} disabled={!form.formState.isValid}>作成</Button>
        </DialogActions>
      </form>
    </FormProvider>
  
  </Dialog>
}
